import React, { useCallback, useEffect, useState } from 'react';
import { LocalUserChoices } from '@livekit/components-react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useCheckCameraError } from '../../../hooks/useCheckCameraError';
import { PreJoin } from '../../LiveKit/PreJoin';

const StyledMain = styled('main')({
  '& .lk-prejoin': {
    backgroundColor: 'transparent!important',
  },
  color: '#444!important',
});

interface IChooseWebcam {
  handleNextStep: (setup: LocalUserChoices) => void;
}

export const ChooseWebcam = ({ handleNextStep }: IChooseWebcam) => {
  const [audioOnly, setAudioOnly] = useState(false);
  const [hasError, setHasError] = useState(false);
  const Error = useCheckCameraError(hasError);

  useEffect(() => {
    (async () => {
      await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: {
          height: { ideal: 1080, min: 360, max: 1080 },
          width: { ideal: 1920, min: 640, max: 1920 },
          aspectRatio: 1.777777778,
        },
      });
    })();
  }, []);

  const handleSetAudioOnly = useCallback(() => {
    setAudioOnly(prev => !prev);
  }, []);

  const handlePreJoinSubmit = useCallback(
    (values: LocalUserChoices) => {
      handleNextStep(values);
    },
    [handleNextStep],
  );

  const onPreJoinError = useCallback(() => {
    setHasError(true);
  }, []);

  return (
    <StyledMain data-lk-theme="default">
      <Box className="block-start block-start-padding">
        <Typography align="center" className="container-explanation-title">
          Choose your devices
        </Typography>

        <section style={{ textAlign: 'center' }}>
          <label htmlFor="audio-only">Audio only</label>
          <Checkbox
            checked={audioOnly}
            id="audio-only"
            onChange={handleSetAudioOnly}
          />
        </section>

        <PreJoin
          defaults={{
            audioEnabled: true,
            videoEnabled: true,
            username: 'TEST',
          }}
          disableName={true}
          disableVideo={audioOnly}
          hideLogin={true}
          joinLabel="Start Test"
          onError={onPreJoinError}
          onSubmit={handlePreJoinSubmit}
          persistUserChoices={false}
        />
      </Box>
      {Error}
    </StyledMain>
  );
};
